/**
 * Compact dialog footer: Avbryt + primary (risk assessment pattern).
 */
export function HseDialogFooter({
  onCancel,
  cancelLabel,
  submitLabel,
  submitting = false,
  submitDisabled = false,
  secondaryLabel,
  onSecondary,
}) {
  return (
    <div className="flex justify-end gap-2 pt-2">
      <button
        type="button"
        onClick={onCancel}
        className="rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700"
      >
        {cancelLabel}
      </button>
      {onSecondary && secondaryLabel ? (
        <button
          type="button"
          onClick={onSecondary}
          className="rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700"
        >
          {secondaryLabel}
        </button>
      ) : null}
      <button
        type="submit"
        disabled={submitting || submitDisabled}
        className="rounded-full bg-[#1463C7] px-5 py-2 text-sm font-semibold text-white disabled:opacity-60"
      >
        {submitLabel}
      </button>
    </div>
  );
}
